import { FormProvider } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useAddDesignerParticipantToReception } from "../../../../api/mutations/constructionSiteSubmission.mutations";
import { DesignerToReceptionForm } from "../../../../component/constructionSites/submission/participants/DesignerToReceptionForm";
import PageLayoutWithTabs from "../../../../component/layout/PageLayoutWithTabs";
import { useDesignerToReceptionForm } from "./useParticipantToReceptionForm";

const AddDesignerReceptionPage = () => {
	const navigate = useNavigate();
	const { constructionSiteId } = useParams<{ constructionSiteId: string }>();

	function goBack() {
		navigate(-1);
	}

	const numericConstructionSiteId = constructionSiteId
		? Number(constructionSiteId)
		: 0;

	const addDesigner = useAddDesignerParticipantToReception(
		numericConstructionSiteId,
	);

	const formApi = useDesignerToReceptionForm({
		mode: "add",
		onSubmit: (data) => addDesigner.mutate(data, { onSuccess: () => goBack() }),
	});

	if (!constructionSiteId) return null;

	return (
		<PageLayoutWithTabs title="Ajouter un concepteur">
			<FormProvider {...formApi.form}>
				<form onSubmit={formApi.handleSubmit}>
					<DesignerToReceptionForm
						constructionSiteId={numericConstructionSiteId}
						onSubmit={formApi.handleSubmit}
						onCancel={goBack}
						isSubmitting={addDesigner.isPending}
					/>
				</form>
			</FormProvider>
		</PageLayoutWithTabs>
	);
};

export default AddDesignerReceptionPage;
